module.exports = __webpack_public_path__ + "img/2-5.6f36f522.png";